/**
 * B2BService — обёртки для собственных эндпоинтов b2b-микросервиса.
 * Auth (login/register/profile) обрабатывает AuthService.
 */
import axios from 'axios';
import {
    API_B2B_pricing,
    API_B2B_requests,
    API_B2B_my_requests,
    API_B2B_my_invoices,
    API_B2B_articles_list,
    API_B2B_article,
    API_B2B_article_comment_post,
} from './API';

const TOKEN_KEY = 'Authorization';
const authHeaders = () => ({ Authorization: localStorage.getItem(TOKEN_KEY) });


export default class B2BService {

    /** Получить актуальный прайс (3 пакета + перерасход). */
    static async getPricing() {
        try {
            const res = await axios.get(API_B2B_pricing);
            return res.data;
        } catch (e) {
            console.error('getPricing:', e);
            return null;
        }
    }

    /**
     * Создать заявку.
     * kind: 'invoice' | 'callback'
     * payload — структурированные данные:
     *   invoice  → {plan: 'yearly_early'|'yearly_standard'|'monthly', amount: number}
     *   callback → {topic: string, message: string, preferred_time?: string}
     * contact: {name?, email?, phone?} — переопределяет данные центра
     */
    static async createRequest({ kind, payload, contact = {} }) {
        try {
            const res = await axios.post(API_B2B_requests, {
                kind,
                payload,
                contact_name:  contact.name,
                contact_email: contact.email,
                contact_phone: contact.phone,
            }, { headers: authHeaders() });
            return { ok: true, request: res.data?.request };
        } catch (e) {
            return {
                ok: false,
                message: e.response?.data?.message || 'Не удалось отправить заявку',
            };
        }
    }

    /** Мои заявки (для отображения в кабинете). */
    static async getMyRequests() {
        try {
            const res = await axios.get(API_B2B_my_requests, { headers: authHeaders() });
            return res.data?.requests || [];
        } catch (e) {
            return [];
        }
    }

    /** Свои счета (без черновиков — их владелец видеть не должен). */
    static async getMyInvoices() {
        try {
            const res = await axios.get(API_B2B_my_invoices, { headers: authHeaders() });
            return res.data?.invoices || [];
        } catch (e) {
            return [];
        }
    }

    // ===== Статьи (категория «integration») =====

    /** Список статей. category по умолчанию 'integration'. */
    static async getArticles({ category = 'integration', search } = {}) {
        try {
            const res = await axios.get(API_B2B_articles_list, {
                params: { category, search, per_page: 100 },
            });
            return res.data?.data || [];
        } catch (e) {
            console.error('getArticles:', e);
            return [];
        }
    }

    /** Одна статья: тело + комментарии. */
    static async getArticle(id) {
        try {
            const res = await axios.get(API_B2B_article + id);
            return res.data?.data || null;
        } catch (e) {
            return null;
        }
    }

    /** Создать комментарий (требует JWT b2b-клиента). */
    static async addComment(articleId, content) {
        try {
            const res = await axios.post(
                API_B2B_article_comment_post + articleId + '/comments',
                { content },
                { headers: authHeaders() },
            );
            return { ok: true, comment: res.data?.comment };
        } catch (e) {
            return {
                ok: false,
                message: e.response?.data?.message || 'Не удалось отправить комментарий',
            };
        }
    }
}
